import { NgModule } from '@angular/core';
import { ModuleWithProviders } from '@angular/core';

import { MycureSDK, MycureSDKConfigToken, SDKServiceProvider } from './service';
export * from './service';

import { Subscription } from 'rxjs';
import { queue } from 'rxjs/scheduler/queue';

import { McWhVariantService } from './wh/wh-variant/wh-variant.service';
import { McWhTransactionService } from './wh/wh-transaction/wh-transaction.service';
import { McWhTrackingService } from './wh/wh-tracking/wh-tracking.service';
import { McWhSupplierService } from './wh/wh-supplier/wh-supplier.service';
import { McSyncbaseConnectionService } from './syncbase/connection/connection.service';
import { McWhProductService } from './wh/wh-product/wh-product.service';
import { McRisOrderService } from './ris/ris-order/ris-order.service';
import { McOrganizationService } from './organization/organization.service';
import { McNotificationService } from './notification/notification.service';
import { McMfPatientService } from './mf/mf-patient/mf-patient.service';
import { McMedRecordService } from './med-record/med-record.service';
import { McClockService } from './clock/clock.service';
import { McLisTestService } from './lis/lis-test/lis-test.service';
import { McLisOrderService } from './lis/lis-order/lis-order.service';
import { McLisMeasureService } from './lis/lis-measure/lis-measure.service';
import { McChatService } from './chat/chat.service';
import { McBillingService } from './billing/billing.service';
import { McAccountService } from './account/account.service';
import { McLisTestAnalyzerService } from './lis/lis-test-analyzer/lis-test-analyzer.service';
import { McPrmService } from './prm/prm.service';
import { McQueueItemService } from './queue-item/queue-item.service';
import { McXlsxService } from './xlsx/xlsx.service';
import { Logger } from './logger/logger.service';
import { McLoaderService } from './loader/loader.service';

@NgModule({
  providers: [ 
    MycureSDK, SDKServiceProvider,
    McAccountService,
    McBillingService,
    McChatService,
    McClockService,
    McLisMeasureService,
    McLisOrderService,
    McLisTestService,
    McLisTestAnalyzerService,
    McMedRecordService,
    McMfPatientService,
    McNotificationService,
    McOrganizationService,
    McPrmService,
    McQueueItemService,
    McRisOrderService,
    McSyncbaseConnectionService,
    McWhProductService,
    McWhSupplierService,
    McWhTrackingService,
    McWhTrackingService,
    McWhTransactionService,
    McWhVariantService,
    McXlsxService,
  ],
  imports: [
   
  ],
  declarations: [
    
  ],
  exports: [
    
  ]
})

export class McServicesModule { 
  static initialize (base: string, config: any): ModuleWithProviders {
    return {
      ngModule: McServicesModule,
      providers: [
        { provide: MycureSDKConfigToken, useValue: { base, config } }
      ]
    }
  }
}

/**
 * TODO: remove this scheduler once Rx has a more robust story for working
 * with zones.
 */
export class ZoneScheduler {

  // TODO: Correctly add ambient zone typings instead of using any.
  constructor(public zone: any) {}

  schedule(...args: any[]): Subscription {
    return <Subscription>this.zone.run(() => queue.schedule.apply(queue, args));
  }
}

export { MycureSDK, MycureSDKConfigToken };
